import React from "react";

const ErrorMessageShow = (text) => (
  <span className="text-danger ms-3">{text} </span>
);

export default ErrorMessageShow;
